import CustomButton from 'components/CustomButton'
import CustomModal from 'components/CustomModal'
import Input from 'components/form/Input'
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { useEffect, useRef, useState } from 'react'
import { auth } from 'db/firebase'
import ProductFaq from './ProductFaq'
import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'

const Faq = () => {
  const [showModal, setShowModal] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = authChanged()

    // Cleanup the subscription when the component unmounts
    return () => unsubscribe()
  }, [])

  const authChanged = () => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setShowModal(false)
      } else {
        setShowModal(true)
      }
    })
    return unsubscribe;
  }

  const login = () => {
    const auth = getAuth()

    signInWithEmailAndPassword(auth, email.trim(), password.trim())
      .then((userCredential) => {
        const user = userCredential.user
        setEmail('')
        setPassword('')
        toast.success('Logged in')
      })
      .catch((error) => {
        const errorMessage = error.message
        toast.error('Username or password invalid')
      })
  }

  const Form = () => {
    return (
      <div className="flex flex-col">
        <Input
          type="text"
          color="blue"
          placeholder="Email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value)
          }}
        />

        <Input
          type="password"
          color="blue"
          placeholder="Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value)
          }}
        />
      </div>
    )
  }

  return (
    <div className="h-auto px-3 -mt-24 md:px-8">
      <div className="container max-w-full mx-auto">
        <div className="px-4 mb-16 grid grid-cols-1">
          <ProductFaq isLogged={!showModal} />
        </div>
      </div>
      <CustomModal
        title="Login Firebase"
        bodyClasses="max-w-md"
        showModal={showModal}
        setShowModal={() => {
          setShowModal(false)
          navigate('/')
        }}
        loading={false}
        children={Form()}
        button={
          <CustomButton disabled={false} onClick={() => login()}>
            Login
          </CustomButton>
        }
      />
    </div>
  )
}

export default Faq
